





























































































import { formatTimeStr } from '@/utils/other';
import { initCompanyActiveTeam } from '@/utils/team';
import { generateOptions } from '@/utils/todo';
import { Pagination } from 'ant-design-vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  titleColumn,
  moduleColumn,
  dueColumn,
  manDayColumn,
} from '../column';

type IGrabTodoInfo = ITodo.IResponse.IGrabTodoInfo;
type ITodoInfo = ITodo.IResponse.ITodoInfo;
interface ITeams {
  [key: string]: string;
}

@Component({
  name: 'TodoListTable',
  components: {},
})
export default class TodoListTable extends Vue {
  @Prop({ default: false }) private spinning!: boolean;
  @Prop({ required: true, default: () => [] }) private todos!: IGrabTodoInfo[];
  @Prop({ default: ''}) private activeKey!: string;
  private pagination = {
    current: 1,
    pageSize: 15,
    hideOnSinglePage: true,
  };
  private searchInput = null;
  private searchText = '';
  private searchedColumn = '';
  private formatTimeStr = formatTimeStr;
  private currentRow: IGrabTodoInfo | null = null;
  private teams: ITeams = {};
  get activeId(): string {
    return this.currentRow?.id || '';
  }
  get columns() {
    const { typeOption, ownerOption, projectOption, settlementUnitOption } =
      generateOptions(this.todos as ITodoInfo[]);
    const typeColumn = {
      key: 'type',
      dataIndex: 'typeName',
      width: '15%',
      slots: { title: 'typeTitle' },
      filters: typeOption,
      onFilter: (value: string, record: IGrabTodoInfo) => {
        return record.typeId === value;
      },
    };
    const ownerColumn = {
      dataIndex: 'ownerName',
      slots: { title: 'ownerTitle' },
      width: '8%',
      filters: ownerOption,
      onFilter: (value: string, record: IGrabTodoInfo) => {
        if (value === 'Null') {
          return record.owner === null;
        }
        return record.owner === value;
      },
    };
    const projectColumn = {
      dataIndex: 'projectName',
      slots: { title: 'projectTitle' },
      scopedSlots: { customRender: 'project' },
      width: '8%',
      filters: projectOption,
      onFilter: (value: string, record: IGrabTodoInfo) => record.projectId === value,
    };
    const settlementUnitColumn = {
      dataIndex: 'settlementConfigurationName',
      slots: { title: 'settlementUnitTitle' },
      width: '8%',
      align: 'center',
      filters: settlementUnitOption,
      onFilter: (value: string, record: IGrabTodoInfo) => record.settlementConfigurationId === value,
    };
    const actionColumn = {
      key: 'action',
      slots: { title: 'actionTitle' },
      scopedSlots: { customRender: 'action' },
      width: '12%',
    };
    return [
      titleColumn,
      moduleColumn,
      typeColumn,
      projectColumn,
      ownerColumn,
      dueColumn,
      manDayColumn,
      settlementUnitColumn,
      actionColumn,
    ];
  }
  @Watch('activeKey', {immediate: true})
  private watchActiveKey(newValue: string) {
    const finded = this.todos.find((todo) => todo.id === newValue);
    if (finded) {
      this.clickRow(finded);
    }
  }
  private created() {
    this.initTeams();
  }
  private getRowClassName(row: IGrabTodoInfo, index: number): string {
    if (row.id === this.activeId) {
      return 'active-tr';
    }
    return '';
  }
  private customRow(row: IGrabTodoInfo, index: number) {
    return {
      on: {
        click: (event: Event) => {
          this.clickRow(row);
        },
      },
    };
  }
  private clickRow(row: IGrabTodoInfo) {
    this.currentRow = row;
  }
  private handleTableChange(pagination: Pagination) {
    this.pagination.current = pagination.current!;
  }
  private handleSearch(
    selectedKeys: string[],
    confirm: () => void,
    dataIndex: string,
  ) {
    confirm();
    this.searchText = selectedKeys[0];
    this.searchedColumn = dataIndex;
  }
  private handleReset(clearFilters: () => void) {
    clearFilters();
    this.searchText = '';
  }
  private goModulePage(moduleId: string) {
    this.$router.push({
      name: 'Module',
      params: {
        id: moduleId,
      },
    });
  }
  private initTeams() {
    initCompanyActiveTeam().then((data) => {
      const res: ITeams = {};
      data.forEach((item) => {
        res[item.id] = item.name;
      });
      this.teams = res;
    });
  }
}
